var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group form-group-sm fg-placement"},[_c('label',[_vm._v("Placements")]),_c('multiselect',{attrs:{"multiple":this.multiple,"options":_vm.placementOptions,"value":_vm.value,"track-by":"v","label":"t","deselect-label":"","select-label":""},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }